<!--todo сделать ссылку ТОЛЬКО по name (посмотреть где используется компонент)-->
<template lang="pug">
  ul.tab-nav
    li.tab-nav__item(
      v-for="tab in tabNavData"
    )
      router-link.tab-nav__link(
      v-if="!nameMode"
      :to="tab.path"
      :active-class="'tab-nav__link_active'"
      ) {{tab.text}}
      router-link.tab-nav__link(
      v-else
      :to="{name: tab.name}"
      :active-class="'tab-nav__link_active'"
      ) {{tab.text}}

</template>
<script>

export default {
  name: "TabNav",
  components: {},
  props: ["tabNavData", "nameMode"]
};
</script>
